module.exports = __webpack_public_path__ + "static/img/2.2ca1d1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/zh/2.png
// module id = /7eP
// module chunks = 0